

import axios from 'axios';
import { buildDecisionsQuery } from './agentFilters';

const AI_BASE_URL = process.env.REACT_APP_AI || "https://ai.sama-tech.ae/pyv1";

export const agentApi = {
  getDecisions: async (params, baseFilters = {}) => {
    const { page, pageSize, filterModel } = params;

    const query = buildDecisionsQuery(page, pageSize, filterModel, baseFilters);

    const response = await axios.get(`${AI_BASE_URL}/decision-engine/decisions`, {
      params: query,
    });
    
    return response.data;
  },
};

export default agentApi;